<template>
	<div id="buildingEnterForm" class='formPage'>
		<formheader :title="title"></formheader>
		<div class="mainContent">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm formWrap">
				<el-form-item label="姓名" prop="appRealname">
					<el-input v-model="ruleForm.appRealname" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="appCellphone">
					<el-input type="text" v-model="ruleForm.appCellphone" placeholder="请输入手机号" @change="filterPhone"></el-input>
				</el-form-item>
				<el-form-item label="公司名称" prop="appCompanyName">
					<el-input v-model="ruleForm.appCompanyName" placeholder="请输入公司"></el-input>
				</el-form-item>
				<el-form-item label="您从事的行业" prop="hy_content">
					<el-input v-model="ruleForm.hy_content" placeholder="请输入您从事的行业"></el-input>
				</el-form-item>
				<el-form-item label="您想了解哪一个政策" class="blockLabel">
					<el-radio-group v-model="ruleForm.zc_content">
						<el-radio :label="'《余杭区“时尚产业新十条”政策》'">《余杭区“时尚产业新十条”政策》</el-radio>
						<el-radio :label="'《余杭区家纺服装传统产业升级改造升级方案》'">《余杭区家纺服装传统产业升级改造升级方案》</el-radio>
						<el-radio :label="'《余杭区“智能制造十条”政策》'">《余杭区“智能制造十条”政策》</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="备注" prop="bz_content" label-width="100px">
					<el-input type="textarea" v-model="ruleForm.bz_content" placeholder="在此输入备注" rows=4 style="padding-top:10px;"></el-input>
				</el-form-item>

				<!--<el-button @click="resetForm('ruleForm')">重置</el-button>-->

			</el-form>
            <div class="btnBox">
                <button id="submitBtn" class="btn-long btn-red" @click="submitForm('ruleForm')">提交</button>
                <a href="tel:0571-86221010">
                    <button  class="btn-long btn-red reverse">
                        <img src="../../images/newImages/but_ic_phone.png" alt="" class="btnIcon"> 0571-86221010 
                    </button>
                </a>
                
            
            </div>
		</div>

	</div>
</template>

<script>
	import formheader from '@/page/formPage/formHeader';
	import axios from 'axios';
	import { ajaxform, ajaxToken } from '@/assets/request.js'
	import { formRule,filterPhoneNum } from '@/assets/common.js'
	export default {
		data() {
			 
			return {
				title: "配套政策申报",
				ruleForm: {
					appRealname: '',
					appCellphone: '',
					appCompanyName: '',
				},
				rules: formRule()

			}
		}, //data end
		components: {
			formheader
		},
		methods: {
				filterPhone(){
				this.ruleForm.appCellphone=filterPhoneNum(this.ruleForm.appCellphone)
			},
			submitForm(formName) {
				let _this = this
				let type = 2 //1为综合体线下实体空间入驻申请，2为相关政策了解申请，3为金融服务申请，4为产业配套服务申请，5为产业互联网服务申请，6为工厂培训申请
				console.log(_this.ruleForm)
				this.$refs[formName].validate((valid) => {
					if(valid) {
						ajaxform(type, "/infoplatform/fashionapplication/applicationMessageEntry", _this.ruleForm).then((res) => {
							console.log("成功res")
							console.log(res)
						}, (res) => {
							console.log("失败res")
							console.log(res)
						})
						//						
					} else {
						console.log('error submit66666666');
                        this.$message({
                        	message:"表单填写不正确",
                        	duration: 1000,
                        });
						return false;
					}
				});
			},
		},
		mounted() {

		}
	}
</script>

<style lang="less">
    // *{outline:1px solid blue;}
    .formPage{
        background: #fff;
        .btnBox{
            padding:0.6rem 0.32rem;
            button.btn-long{font-size: 0.36rem ;margin-bottom: 0.4rem;}
            .btnIcon{
                width: 0.48rem;height: 0.48rem; vertical-align: bottom;
            }
        }
    }
    .el-form-item{
        // outline:1px solid blue;
        background: #fff; padding:0 0.32rem; 
        border-bottom: 1px solid #eee;
    }
	/*表单label比较长的部分样式*/
	
	.formWrap .blockLabel {
		.el-form-item__label {
			display: block;
			width: 100% !important;
			text-align: left !important;
			text-align-last: auto !important;
            
		}
		.el-radio__label {
			font-size: 0.29rem; color:#111A34; font-weight: bold;
		}
		.el-form-item__content {
			margin-left: 0.1rem !important;
			;
		}
		.el-radio {
			display: block !important;
			line-height: 5;
            border-bottom: 1px solid #eee; 
		}
		.el-radio+.el-radio {
			margin-left: 0 !important;
		}
	}
	
	.formWrap {
        background: #fff; padding-top:0.22rem;
		// padding: 0.8rem 0.7rem 0.2rem;
		/*输入框*/
		.el-input__inner {
			// height: 0.75rem;
			// line-height: 0.75rem;
            border:none;
            padding-bottom: 0.22rem;
            padding-left:0;
		}
		.el-textarea__inner {
			padding: 0px 10px;
		}
		/*标签*/
		.el-form-item__label {
			// font-weight: bold;
			text-align: left;
			// text-align-last: justify;
			/*padding-left:0.7rem;*/
		}
		.el-form-item {
			margin-bottom: 0.2rem;
		}
		.el-form-item__error {
			padding-top: 0;
		}
		.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
			margin-right: 0;
		}
        textarea{border:0;}
	}
    
</style>


// WEBPACK FOOTER //
// src/page/formPage/policyForm.vue